import { Injectable } from "@angular/core";

import { Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { oneDark } from "@codemirror/theme-one-dark";

import { CodeEditorTooltipService } from "./code-editor-tooltip.service";


@Injectable()
export class CodeEditorThemeService {

    constructor(private tooltipService: CodeEditorTooltipService) {
    }

    public getThemeExtension(): Extension[] {

        const tooltipStyle: Extension = this.tooltipService.getTooltipStyleExtension();

        const tooltipPosition: Extension = this.tooltipService.getTooltipPositionExtension();

        return [oneDark, tooltipStyle, tooltipPosition, EditorView.lineWrapping];
    }
}